// src/redux/slices/library/bookAuthor.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookAuthorType } from "../../../types/Library";

const initialState: BookAuthorType = {
    idAuthor: "",
    idBook: ""
};

const bookAuthorSlice = createSlice({
    name: "bookAuthor",
    initialState,
    reducers: {
        setBookAuthorData: (state, action: PayloadAction<BookAuthorType>) => ({
            ...state,
            ...action.payload,
        }),
        resetBookAuthorData: () => initialState,
    },
});

export const { setBookAuthorData, resetBookAuthorData } = bookAuthorSlice.actions;
export default bookAuthorSlice.reducer;
